import { logout } from "./authSlice";

/**
 * Log out and land on /login via a **full-page navigation**.
 *
 * Mirrors apps/web's performLogout: awaits the shared `logout` thunk (Firebase
 * `signOut` + auth-cache clear) so it settles before unload, then
 * `window.location.assign` triggers a real document load — re-fetching
 * `index.html` so the post-logout session comes up on the latest deployed
 * bundle rather than a stale long-open tab.
 *
 * Tolerates a rejected `logout` (e.g. a Firebase `signOut` error) — we still
 * hard-navigate, so a broken session can't strand the user.
 *
 * @param {import("@reduxjs/toolkit").Dispatch} dispatch - the store dispatch.
 * @param {string} [infoCode] - optional `?info=` banner code shown on the login
 *   page (e.g. `"session_expired"` for an idle/session-loss logout). Omit for a
 *   plain user-initiated logout, which lands on /login with no banner.
 */
export async function performLogout(dispatch, infoCode) {
  try {
    await dispatch(logout()).unwrap();
  } catch {
    // logout thunk rejected — hard-navigate anyway.
  }
  window.location.assign(
    infoCode ? `/login?info=${encodeURIComponent(infoCode)}` : "/login",
  );
}
